// Altitude (vigor) zone balance data, keyed by altitude level. Values are
// transcribed directly from the Fortress Ascent rulebook.
import { VIGOR_ZONES, } from "../types/vigor_zones.js";
export const VIGOR_ZONES_CONFIG = {
    0: {
        name: "forest",
        permanentResourceBonus: [0, 0, 0, 0],
        oneTimeResourceBonus: [0, 0, 0, 0],
        vigorPenalty: 0,
        barracksAttackUpkeep: 1,
    },
    1: {
        name: "foothill",
        permanentResourceBonus: [0, 0, 0, 0],
        oneTimeResourceBonus: [0, 0, 0, 0],
        vigorPenalty: 0,
        barracksAttackUpkeep: 1,
    },
    2: {
        name: "ridgeline",
        permanentResourceBonus: [1, 1, 1, 1],
        oneTimeResourceBonus: [1, 1, 1, 1],
        vigorPenalty: 1,
        barracksAttackUpkeep: 2,
    },
    3: {
        name: "crag",
        permanentResourceBonus: [2, 2, 2, 2],
        oneTimeResourceBonus: [2, 2, 2, 2],
        vigorPenalty: 3,
        barracksAttackUpkeep: 3,
    },
    4: {
        name: "summit",
        permanentResourceBonus: [3, 3, 3, 3],
        oneTimeResourceBonus: [3, 3, 3, 3],
        vigorPenalty: 5,
        barracksAttackUpkeep: 4,
    },
};
/**
 * Node counts per altitude on the physical board. The board's 63 large tiles
 * carry these many movement nodes each zone (summit 24 / crag 168 / ridgeline
 * 450 / foothill 750 / forest 384 = 1776). A node's vigor zone is determined by
 * the tile placed over it at board assembly — see `assembleBoard` / the tile
 * catalogue in `tiles/`.
 */
export const VIGOR_ZONE_NODE_COUNTS = {
    4: 24,
    3: 168,
    2: 450,
    1: 750,
    0: 384,
};
/**
 * A zone name's altitude level — its key into the level-indexed tables. The
 * level is simply the name's position in `VIGOR_ZONES` (forest 0 … summit 4).
 */
export function vigorZoneLevel(zone) {
    return VIGOR_ZONES.indexOf(zone);
}
/**
 * Energy zones as the RULES count them (Wei, 2026-10-17): forest and foothill
 * are always ONE zone — the lowest — then ridgeline, crag and summit: four in
 * all. Altitude LEVELS (0–4) still key the balance tables above; use these
 * wherever zones are compared or counted ("same energy zone", "every energy
 * zone", "the lowest energy zone").
 */
export const ENERGY_ZONE_COUNT = 4;
/** The energy zone (0 = lowest … 3 = summit) an altitude level belongs to. */
export function energyZoneOf(level) {
    return Math.max(0, level - 1);
}
//# sourceMappingURL=vigor_zones.js.map